export default () => ({
  isShown: false,
  menuItemsList: [],
});
